import {ThemeMode, useThemeSettings} from '@hconnect/uikit'
import {MenuItemConfig} from '@hm/fundamental'
import {mdiMonitor, mdiThemeLightDark, mdiWeatherNight, mdiWeatherSunny} from '@mdi/js'
import {useCallback, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

export function useThemeMenuItem(): MenuItemConfig {
  const {t} = useTranslation()
  const {themeMode, setThemeMode} = useThemeSettings()

  const selectThemeMode = useCallback(
    (mode: string) => setThemeMode(mode as ThemeMode),
    [setThemeMode]
  )

  return useMemo(() => {
    const subtitleByMode: Record<ThemeMode, string> = {
      [ThemeMode.Light]: t('suite.header.theme.light'),
      [ThemeMode.Dark]: t('suite.header.theme.dark'),
      [ThemeMode.Device]: t('suite.header.theme.device')
    }

    return {
      key: 'theme',
      title: t('suite.header.theme.label'),
      subtitle: subtitleByMode[themeMode],
      icon: mdiThemeLightDark,
      type: 'select',
      onClicked: selectThemeMode,
      selectedItem: themeMode,
      items: [
        {
          key: ThemeMode.Light,
          title: t('suite.header.theme.light'),
          icon: mdiWeatherSunny
        },
        {
          key: ThemeMode.Dark,
          title: t('suite.header.theme.dark'),
          icon: mdiWeatherNight
        },
        {
          key: ThemeMode.Device,
          title: t('suite.header.theme.device'),
          icon: mdiMonitor
        }
      ]
    }
  }, [themeMode, selectThemeMode, t])
}
